<template>
  <form-section-checkbox
    v-model="event_mode"
    :title="$t('CampaignForm_Events_Delay_Title')"
    :description="$t('CampaignForm_Events_Delay_Description')"
    :is-changed="model.diff && model.diff.includes('eventDelay')"
  >
    <div class="delay-ct">
      <form-item
        :label="$t('CampaignForm_Events_Delay_Delay')"
        prop="event_delay_time"
      >
        <el-input-number
          class="delay-input-number"
          v-model="model.event_delay_time"
          :controls="false"
          :min="0"
          :max="1000"
        />
      </form-item>
      <form-item prop="event_delay_period" label=" ">
        <el-select v-model="model.event_delay_period">
          <el-option
            value="minutes"
            :label="$t('CampaignForm_Events_Delay_Minutes')"
          />
          <el-option
            value="hours"
            :label="$t('CampaignForm_Events_Delay_Hours')"
          />
          <el-option
            value="days"
            :label="$t('CampaignForm_Events_Delay_Days')"
          />
        </el-select>
      </form-item>
    </div>
  </form-section-checkbox>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import FormSectionCheckbox from '@/common/components/form/FormSectionCheckbox'
export default {
  name: 'Delay',

  components: {
    FormSectionCheckbox,
    FormItem
  },

  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      event_mode: 0
    }
  },

  watch: {
    event_mode: function(value) {
      this.model.event_mode = value + 1
    }
  },

  mounted() {
    if (
      !Number.isNaN(this.model.event_mode) &&
      parseInt(this.model.event_mode) === 2
    ) {
      this.event_mode = 1
    }
  }
}
</script>

<style scoped>
.delay-ct {
  display: flex;
}

.delay-ct > div:first-of-type {
  width: 90px;
}

.delay-ct > div:last-of-type >>> .el-input__inner {
  width: 165px;
}

.delay-input-number >>> .el-input__inner {
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/events/Delay.vue